<template>
  <form-wrapper @submit="onSubmit">
    <div slot="box" v-loading="loading">
      <div>
        <component-compiler
          v-for="(component, i) in getFields()"
          :key="`form-${i}`"
          :content="component"
        />
        <map-preview :preview-content="previewContent" @mapData="handleData" />
      </div>
    </div>
    <form-nav
      slot="navbar"
      :loading="loading"
      :redirect-route="redirectRoute"
      :in-modal="inModal"
      :hide-multilingual="hideMultilingual"
      @submit="onSubmit"
    >
      <component-compiler
        v-for="(component, i) in getNavButtons()"
        :key="`form-${i}`"
        :content="component"
      />
    </form-nav>
  </form-wrapper>
</template>
<script>
import FormNav from './FormNav'
import FormWrapper from './FormWrapper'
import { cloneDeep, get } from 'lodash'
import ComponentCompiler from '@/components/ComponentCompiler'
import MapPreview from '@/crudBases/form/MapPreview.vue'
import confirmLeave from '@/mixins/confirmLeave'
import { isEmpty } from 'lodash'

export default {
  components: {
    ComponentCompiler,
    FormNav,
    FormWrapper,
    MapPreview
  },
  mixins: [confirmLeave],
  props: {
    id: {
      type: [Number, String],
      required: false
    },
    slug: {
      type: String,
      required: false
    },
    inModal: {
      // used as form in dialog
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {},
      errors: {},
      singleton: false,
      redirectRoute: null, // To extend
      hideMultilingual: false,
      lookupKwarg: 'id',
      livePreview: true,
      previewContent: null,
      previewContentLoading: false
    }
  },
  computed: {
    previewAvailable() {
      return !!this.previewContent
    },
    lookupParams() {
      if (get(this, this.lookupKwarg)) {
        const params = {}
        params[this.lookupKwarg] = this.id
        return params
      } else if (this.slug) {
        return { slug: this.slug }
      }
      return null
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    getNavButtons() {},
    getFields() {},
    handleData(data) {
      this.form.data = data
    },
    fetchData() {
      if (this.lookupParams || this.singleton) {
        this.loading = true
        this.service
          .get(this.lookupParams)
          .then(response => {
            this.form = response.data
            this.instanceFetchCallback()
            this.formCopy = cloneDeep(this.form)
            this.previewContent = this.form.data
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    onSubmit() {
      const isEmptyAndActive = this.form.is_active && isEmpty(this.form.data)

      if (isEmptyAndActive)
        return this.$message({
          message: 'Mapa musi zawierać obiekty aby była aktywna',
          type: 'error'
        })

      this.loading = true
      this.errors = {}
      const id = this.lookupParams
      const payload = { ...this.form }
      const service =
        id || this.singleton
          ? this.service.update(this.lookupParams, payload)
          : this.service.save(payload)
      service
        .then(response => {
          this.successRedirect = true
          this.successHandler(response)
        })
        .catch(this.errorHandler)
    }
  }
}
</script>
